/* A vendor's LinkedIn company page is found automatically from a link on the vendor's own website
   (backend services/linkedin_lookup.py) when the vendor is added or pre-onboarded. It is display-only:
   users never type or edit it. */

export const linkedInHref = (value: string) => (/^https?:\/\//i.test(value) ? value : `https://${value}`);

/** The LinkedIn mark on its own (no link). */
export function LinkedInIcon({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
      <rect width="24" height="24" rx="4" fill="#0A66C2" />
      <path fill="#fff" d="M7.1 9.6h-2.6V19h2.6V9.6ZM5.8 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm13.7 8.6c0-2.6-1.4-4.2-3.6-4.2-1.3 0-2.1.7-2.5 1.3V9.6h-2.6V19h2.6v-5c0-1.3.6-2.2 1.7-2.2 1.1 0 1.6.8 1.6 2.2v5h2.7v-5.4Z" />
    </svg>
  );
}

/** Small LinkedIn mark linking to the page, for drawers and records. */
export function LinkedInLink({ url, size = 16, title }: { url: string; size?: number; title?: string }) {
  return (
    <a href={linkedInHref(url)} target="_blank" rel="noopener noreferrer" title={title || 'Open LinkedIn page'} aria-label="LinkedIn page"
      style={{ display: 'inline-flex', alignItems: 'center', lineHeight: 0 }}>
      <LinkedInIcon size={size} />
    </a>
  );
}
